module.exports = __webpack_public_path__ + "img/2.0f303849.png";